import { schemas } from "../Constants"
import Table from "./BaseTable"
import { makeEntityId } from "./CommonColumns"
import { transformDisplayValue, buildDropdownItems } from "../../utils/databaseAppUtils"
import { Plant } from "./Project"


class ReportTypeTable extends Table {

    constructor() {
        var columnSchema = {
            id: "id",
            name: "name"
        }

        var schemaName = schemas.dbo
        var tableName = "report_type"

        var displayNameSingular = "Report Type"
        var displayNamePlural = "Report Types"

        var pkUidColumn = columnSchema.id
        var identifiers = [columnSchema.id]
        var dependencies = []
        
        super(
            schemaName, tableName, 
            columnSchema,
            displayNameSingular, displayNamePlural, 
            identifiers, dependencies, pkUidColumn
        )
        this.allowProjectDisplay = false
    }

    buildTableProps = (data) => {

        return {
            itemSchema: this.buildNewRecord(),
            buildRequestBody: this.buildRequestBody.bind(this),
            tableConfig: {
                columns: [
                    makeEntityId(this.columnSchema.id, {fixed: true}),
                    {
                        name: "Name",
                        key: this.columnSchema.name,
                        cellType: "editable",
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true
                        }
                    }
                ]
            },
        }
    }

}
export const ReportType = new ReportTypeTable()

class ReportTable extends Table {

    constructor() {
        var columnSchema = {
            id: "id",
            name: "name",
            reportTypeId: "report_type_id",
            datasetDate: "dataset_date"
        }

        var schemaName = schemas.dbo
        var tableName = "report"

        var displayNameSingular = "Report"
        var displayNamePlural = "Reports"

        var pkUidColumn = columnSchema.id
        var identifiers = [columnSchema.id]
        var dependencies = [ReportType]
        
        super(
            schemaName, tableName, 
            columnSchema,
            displayNameSingular, displayNamePlural, 
            identifiers, dependencies, pkUidColumn
        )
        this.allowProjectDisplay = false
    }

    buildTableProps = (data) => {

        var reportTypeRecords = this.findTableObjectRecords(data, ReportType)
        var reportTypeIdCol = ReportType.columnSchema.id
        var reportTypeNameCol = ReportType.columnSchema.name

        return {
            itemSchema: this.buildNewRecord(),
            buildRequestBody: this.buildRequestBody.bind(this),
            tableConfig: {
                columns: [
                    makeEntityId(this.columnSchema.id, {fixed: true}),
                    {
                        name: "Name",
                        key: this.columnSchema.name,
                        cellType: "editable",
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true
                        }
                    }, {
                        name: "Report Type",
                        key: this.columnSchema.reportTypeId,
                        cellType: "dropdown",
                        cellOptions: {
                            transformDisplayValue: (value) => transformDisplayValue(reportTypeRecords, value, reportTypeIdCol, reportTypeNameCol),
                            dropdownItems: buildDropdownItems(reportTypeRecords, reportTypeIdCol, reportTypeNameCol),
                        },
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true,
                            fixed: true
                        }
                    }, {
                        name: "Dataset Date",
                        key: this.columnSchema.datasetDate,
                        cellType: "date",
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true
                        }
                    }
                ]
            },
        }
    }

}
export const Report = new ReportTable()

class ReportCommentTopicTable extends Table {

    constructor() {
        var columnSchema = {
            id: "id",
            name: "name"
        }

        var schemaName = schemas.dbo
        var tableName = "report_comment_topic"

        var displayNameSingular = "Report Comment Topic"
        var displayNamePlural = "Report Comment Topics"

        var pkUidColumn = columnSchema.id
        var identifiers = [columnSchema.id]
        var dependencies = []
        
        super(
            schemaName, tableName, 
            columnSchema,
            displayNameSingular, displayNamePlural, 
            identifiers, dependencies, pkUidColumn
        )
        this.allowProjectDisplay = false
    }

    buildTableProps = (data) => {

        return {
            itemSchema: this.buildNewRecord(),
            buildRequestBody: this.buildRequestBody.bind(this),
            tableConfig: {
                columns: [
                    makeEntityId(this.columnSchema.id, {fixed: true}),
                    {
                        name: "Name",
                        key: this.columnSchema.name,
                        cellType: "editable",
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true
                        }
                    }
                ]
            },
        }
    }

}
export const ReportCommentTopic = new ReportCommentTopicTable()

class ReportRelevantCommentTopicsTable extends Table {

    constructor() {
        var columnSchema = {
            id: "id",
            reportTypeId: "report_type_id",
            reportCommentTopicId: "report_comment_topic_id"
        }

        var schemaName = schemas.dbo
        var tableName = "report_relevant_comment_topics"

        var displayNameSingular = "Report Relevant Comment Topic"
        var displayNamePlural = "Report Relevant Comment Topics"

        var pkUidColumn = columnSchema.id
        var identifiers = [columnSchema.id]
        var dependencies = [ReportType, ReportCommentTopic]
        
        super(
            schemaName, tableName, 
            columnSchema,
            displayNameSingular, displayNamePlural, 
            identifiers, dependencies, pkUidColumn
        )
        this.allowProjectDisplay = false
    }

    buildTableProps = (data) => {

        var reportTypeRecords = this.findTableObjectRecords(data, ReportType)
        var reportTypeIdCol = ReportType.columnSchema.id
        var reportTypeNameCol = ReportType.columnSchema.name
        
        var reportCommentTopicRecords = this.findTableObjectRecords(data, ReportCommentTopic)
        var reportCommentTopicIdCol = ReportCommentTopic.columnSchema.id
        var reportCommentTopicNameCol = ReportCommentTopic.columnSchema.name

        return {
            itemSchema: this.buildNewRecord(),
            buildRequestBody: this.buildRequestBody.bind(this),
            tableConfig: {
                columns: [
                    makeEntityId(this.columnSchema.id, {fixed: true}),
                    {
                        name: "Report Type",
                        key: this.columnSchema.reportTypeId,
                        cellType: "dropdown",
                        cellOptions: {
                            transformDisplayValue: (value) => transformDisplayValue(reportTypeRecords, value, reportTypeIdCol, reportTypeNameCol),
                            dropdownItems: buildDropdownItems(reportTypeRecords, reportTypeIdCol, reportTypeNameCol),
                        },
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true,
                            fixed: true
                        }
                    }, {
                        name: "Report Comment Topic",
                        key: this.columnSchema.reportCommentTopicId,
                        cellType: "dropdown",
                        cellOptions: {
                            transformDisplayValue: (value) => transformDisplayValue(reportCommentTopicRecords, value, reportCommentTopicIdCol, reportCommentTopicNameCol),
                            dropdownItems: buildDropdownItems(reportCommentTopicRecords, reportCommentTopicIdCol, reportCommentTopicNameCol),
                        },
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true,
                            fixed: true
                        }
                    }
                ]
            },
        }
    }

}
export const ReportRelevantCommentTopics = new ReportRelevantCommentTopicsTable()

class ReportCommentTable extends Table {

    constructor() {
        var columnSchema = {
            id: "id",
            reportId: "report_id",
            topicId: "topic_id",
            assetAssociationTable: "asset_association_table",
            assetAssociationId: "asset_association_id",
            content: "content"
        }

        var schemaName = schemas.dbo
        var tableName = "report_comment"

        var displayNameSingular = "Report Comment"
        var displayNamePlural = "Report Comments"

        var pkUidColumn = columnSchema.id
        var identifiers = [columnSchema.id]
        var dependencies = []
        
        super(
            schemaName, tableName, 
            columnSchema,
            displayNameSingular, displayNamePlural, 
            identifiers, dependencies, pkUidColumn
        )
        this.allowProjectDisplay = false
    }

    buildTableProps = (data) => {

        return {
            itemSchema: this.buildNewRecord(),
            buildRequestBody: this.buildRequestBody.bind(this),
            tableConfig: {
                columns: [
                    makeEntityId(this.columnSchema.id, {fixed: true})
                ]
            },
        }
    }

}
export const ReportComment = new ReportCommentTable()















class ConstructionActivityScheduleTable extends Table {

    constructor() {
        var columnSchema = {
            oid: "oid",
            name: "name",
            projectId: "project_id",
            date: "date"
        }

        var schemaName = schemas.dbo
        var tableName = "construction_activity_schedule"

        var displayNameSingular = "Construction Activity Schedule"
        var displayNamePlural = "Construction Activity Schedules"

        var pkUidColumn = columnSchema.oid
        var identifiers = [columnSchema.oid]
        var dependencies = [Plant]
        
        super(
            schemaName, tableName, 
            columnSchema,
            displayNameSingular, displayNamePlural, 
            identifiers, dependencies, pkUidColumn
        )
        this.allowProjectDisplay = false
    }

    buildTableProps = (data) => {

        var projectRecords = this.findTableObjectRecords(data, Plant)
        var projectIdCol = Plant.columnSchema.plant_id
        var projectNameCol = Plant.columnSchema.plant_name

        return {
            itemSchema: this.buildNewRecord(),
            buildRequestBody: this.buildRequestBody.bind(this),
            tableConfig: {
                columns: [
                    makeEntityId(this.columnSchema.oid, {fixed: true}),
                    {
                        name: "Name",
                        key: this.columnSchema.name,
                        cellType: "editable",
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true
                        }
                    }, {
                        name: "Project",
                        key: this.columnSchema.projectId,
                        cellType: "dropdown",
                        cellOptions: {
                            transformDisplayValue: (value) => transformDisplayValue(projectRecords, value, projectIdCol, projectNameCol),
                            dropdownItems: buildDropdownItems(projectRecords, projectIdCol, projectNameCol),
                        },
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true,
                            fixed: true
                        }
                    }, {
                        name: "Date",
                        key: this.columnSchema.date,
                        cellType: "date",
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true
                        }
                    }
                ]
            },
        }
    }

}
export const ConstructionActivitySchedule = new ConstructionActivityScheduleTable()

class ConstructionActivityTable extends Table {

    constructor() {
        var columnSchema = {
            oid: "oid",
            name: "name",
            applicableTechnologyType: "applicable_technology_type"
        }

        var schemaName = schemas.dbo
        var tableName = "construction_activity"

        var displayNameSingular = "Construction Activity"
        var displayNamePlural = "Construction Activities"

        var pkUidColumn = columnSchema.oid
        var identifiers = [columnSchema.oid]
        var dependencies = []
        
        super(
            schemaName, tableName, 
            columnSchema,
            displayNameSingular, displayNamePlural, 
            identifiers, dependencies, pkUidColumn
        )
        this.allowProjectDisplay = false
    }

    buildTableProps = (data) => {

        return {
            itemSchema: this.buildNewRecord(),
            buildRequestBody: this.buildRequestBody.bind(this),
            flattenItem: (x) => {
                x[this.columnSchema.applicableTechnologyType] = x[this.columnSchema.applicableTechnologyType] ? x[this.columnSchema.applicableTechnologyType].split(",") : []
                return x
            },
            structureItem: (x) => {
                x[this.columnSchema.applicableTechnologyType] = x[this.columnSchema.applicableTechnologyType] ? x[this.columnSchema.applicableTechnologyType].join(",") : null
                return x
            },
            tableConfig: {
                columns: [
                    makeEntityId(this.columnSchema.oid, {fixed: true}),
                    {
                        name: "Name",
                        key: this.columnSchema.name,
                        cellType: "editable",
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true
                        }
                    }, {
                        name: "Technology",
                        key: this.columnSchema.applicableTechnologyType,
                        cellType: "dropdown",
                        cellOptions: {
                            dropdownItems: Plant.options.technology,
                            multiSelect: true,
                            /*transformNewValue: (newValue, newValueColumn, record, items) => {
                                return {
                                    [newValueColumn]: newValue.length > 0 ? newValue.join() : null
                                }
                            }*/
                        },
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true,
                            fixed: true
                        }
                    }
                ]
            },
        }
    }

}
export const ConstructionActivity = new ConstructionActivityTable()

class ConstructionActivityScheduleEntryTable extends Table {

    constructor() {
        var columnSchema = {
            oid: "oid",
            scheduleId: "schedule_id",
            activityId: "activity_id",
            completionActual: "completion_actual__pct",
            completionScheduled: "completion_scheduled__pct",
        }

        var schemaName = schemas.dbo
        var tableName = "construction_activity_schedule_entry"

        var displayNameSingular = "Construction Activity Schedule Entry"
        var displayNamePlural = "Construction Activity Schedule Entries"

        var pkUidColumn = columnSchema.oid
        var identifiers = [columnSchema.oid]
        var dependencies = [ConstructionActivitySchedule, ConstructionActivity]
        
        super(
            schemaName, tableName, 
            columnSchema,
            displayNameSingular, displayNamePlural, 
            identifiers, dependencies, pkUidColumn
        )
        this.allowProjectDisplay = false
    }

    buildTableProps = (data) => {

        var scheduleRecords = this.findTableObjectRecords(data, ConstructionActivitySchedule)
        var scheduleIdCol = ConstructionActivitySchedule.columnSchema.oid
        var scheduleNameCol = ConstructionActivitySchedule.columnSchema.name
        
        var activityRecords = this.findTableObjectRecords(data, ConstructionActivity)
        var activityIdCol = ConstructionActivity.columnSchema.oid
        var activityNameCol = ConstructionActivity.columnSchema.name

        return {
            itemSchema: this.buildNewRecord(),
            buildRequestBody: this.buildRequestBody.bind(this),
            tableConfig: {
                columns: [
                    makeEntityId(this.columnSchema.oid, {fixed: true}),
                    {
                        name: "Schedule",
                        key: this.columnSchema.scheduleId,
                        cellType: "dropdown",
                        cellOptions: {
                            transformDisplayValue: (value) => transformDisplayValue(scheduleRecords, value, scheduleIdCol, scheduleNameCol),
                            dropdownItems: buildDropdownItems(scheduleRecords, scheduleIdCol, scheduleNameCol),
                        },
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true,
                            fixed: true
                        }
                    }, {
                        name: "Activity",
                        key: this.columnSchema.activityId,
                        cellType: "dropdown",
                        cellOptions: {
                            transformDisplayValue: (value) => transformDisplayValue(activityRecords, value, activityIdCol, activityNameCol),
                            dropdownItems: buildDropdownItems(activityRecords, activityIdCol, activityNameCol),
                        },
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true,
                            fixed: true
                        }
                    }, {
                        name: "Completion Actual (%)",
                        key: this.columnSchema.completionActual,
                        cellType: "editable",
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true
                        }
                    }, {
                        name: "Completion Scheduled (%)",
                        key: this.columnSchema.completionScheduled,
                        cellType: "editable",
                        filterable: true,
                        sortable: true,
                        colProps: {
                            width: 200,
                            resizable: true
                        }
                    }
                ]
            },
        }
    }

}
export const ConstructionActivityScheduleEntry = new ConstructionActivityScheduleEntryTable()